import axios from '@/utils/request'
var Qs = require('qs')
export default {
	// 2021-07-16
	findByUuid(params) {
		return axios.get('/mms/order-extrainfos/find-by-uuid', params)
	},
	// 2021-07-16
	create(params) {
		return axios.post('/mms/order-extrainfos', params)
	},
}

